import { render } from "./StaffCustomerPage.vue?vue&type=template&id=22027896&ts=true"
import script from "./StaffCustomerPage.vue?vue&type=script&lang=ts"
export * from "./StaffCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__